import React, { useState } from "react";
import { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import Footer from "./components/footer";
import Logo from "./components/logo";
import GooglePayButton from "./components/GooglePayButton";
import TurnstileWidget from "./components/TurnstileWidget";
import {
  getPaymentTransaction,
  processPayment,
  recordGooglePayTransaction,
} from "./utilities/axios";

const Home = () => {
  const [cardNumber, setCardNumber] = useState("");
  const [cardName, setCardName] = useState("");
  const [expiration, setExpiration] = useState("");
  const [cvv, setCvv] = useState("");
  const [saveCard, setSaveCard] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState("");
  const [turnstileResetCounter, setTurnstileResetCounter] = useState(0);

  const [amount, setAmount] = useState(null);
  const [autoPayDiscount, setAutoPayDiscount] = useState(0);
  const [error, setError] = useState(null);
  const [returnUrl, setReturnUrl] = useState("");
  const [cancelUrl, setCancelUrl] = useState("");

  const urlParams = new URLSearchParams(window.location.search);
  const paymentGuid = urlParams.get("paymentGuid");
  const turnstileSiteKey =
    process.env.REACT_APP_TURNSTILE_SITE_KEY || "0x4AAAAAACl1bd7ovOa17ryI";
  const handleCancel = () => {
    window.location.href = cancelUrl;
  };

  useEffect(() => {
    if (!paymentGuid) {
      setError("Invalid payment GUID");
      return;
    }

    getPaymentTransaction(paymentGuid)
      .then((response) => {
        const apiData = response.data.Data || response.data;
        const payment = apiData.content;
        if ((response.data.Success || apiData.isSuccess) && payment) {
          setAmount(payment.amount);
          setAutoPayDiscount(payment.autoPayDiscount);
          setCancelUrl(payment.cancelUrl);
          setReturnUrl(payment.returnUrl);
        } else {
          setError("Failed to fetch payment details");
        }
      })
      .catch((err) => {
        console.error("Error fetching payment info:", err);
        setError("Failed to fetch payment details");
      });
  }, [paymentGuid]);
  const displayAmount = saveCard ? amount - autoPayDiscount : amount;
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setError("");

    if (!paymentGuid) {
      setError("Invalid payment GUID");
      setIsSubmitting(false);
      return;
    }
    if (!turnstileToken) {
      setError("Please complete the security verification.");
      setIsSubmitting(false);
      return;
    }

    if (!turnstileToken) {
      setError("Please complete the security verification.");
      setIsSubmitting(false);
      return;
    }

    const cardData = {
      CreditCardNumber: cardNumber,
      CreditCardName: cardName,
      CCV: cvv,
      ExpirationMonth: expiration.split("/")[0].padStart(2, "0"),
      ExpirationYear: `20${expiration.split("/")[1]}`,
      SaveCard: saveCard,
      TurnstileToken: turnstileToken,
    };
    let shouldResetTurnstile = true;

    // COMMENTED OUT: Sending CardLookup request
    // console.log("Sending CardLookup request with data:", {
    //   paymentGuid,
    //   cardNumber: cardNumber.substring(0, 4) + "****" + cardNumber.substring(cardNumber.length - 4),
    //   cardName: cardData.CreditCardName,
    //   expirationMonth: cardData.ExpirationMonth,
    //   expirationYear: cardData.ExpirationYear
    // });

    try {
      // COMMENTED OUT: CardLookup step
      // const cardLookupResponse = await cardLookUp(paymentGuid, cardData);
      //
      // console.log("CardLookup Full Response:", cardLookupResponse);
      // console.log("CardLookup Response Data:", cardLookupResponse.data);
      //
      // const responseData = cardLookupResponse.data;
      // const alertMessage = `
      // MONERIS CARDLOOKUP RESPONSE:
      //
      // Status: ${cardLookupResponse.status}
      //
      // Response Data:
      //    Message: ${responseData.message || "(empty - success)"}
      //    Order ID: ${responseData.orderId || "N/A"}
      //    Client ID: ${responseData.cnumOaid || "N/A"}
      //    Amount: $${responseData.amount || "N/A"}
      //    Currency: ${responseData.currency || "N/A"}
      //
      // ${responseData.message ? "This means there was an issue with card validation" : "Card validation successful!"}
      //       `;
      //
      // alert(alertMessage);
      //
      // if (responseData.message && responseData.message !== "") {
      //   setError(`Card verification failed: ${responseData.message}`);
      //   setIsSubmitting(false);
      //   return;
      // }
      //
      // if (!responseData.cnumOaid || !responseData.orderId) {
      //   setError("Card verification failed - missing required data.");
      //   setIsSubmitting(false);
      //   return;
      // }
      //
      // console.log("Card validated successfully! Proceeding to payment...");

      console.log("Sending ProcessPayment request with data:", {
        paymentGuid,
        cardNumber:
          cardNumber.substring(0, 4) +
          "****" +
          cardNumber.substring(cardNumber.length - 4),
        cardName: cardData.CreditCardName,
        expirationMonth: cardData.ExpirationMonth,
        expirationYear: cardData.ExpirationYear.slice(-2),
        saveCard: cardData.SaveCard,
      });

      const processPaymentResponse = await processPayment(
        paymentGuid,
        cardData,
      );

      console.log("ProcessPayment Full Response:", processPaymentResponse);
      console.log("ProcessPayment Response Data:", processPaymentResponse.data);

      const paymentResult =
        processPaymentResponse.data?.Data?.content ||
        processPaymentResponse.data?.content ||
        processPaymentResponse.data;

      const resultMessage = `
PAYMENT RESULT:
      
Status: ${paymentResult.isSuccess ? "SUCCESS" : "FAILED"}

Details:
   Message: ${paymentResult.message}
   Order ID: ${paymentResult.orderId || "N/A"}
   Transaction ID: ${paymentResult.transactionId || "N/A"}
   Response Code: ${paymentResult.responseCode || "N/A"}
   Amount: $${paymentResult.amount || "N/A"}

${
  paymentResult.isSuccess
    ? "Payment completed! Redirecting..."
    : "Payment was declined. Please try again."
}
      `;
      console.log("Payment Result Message:", resultMessage);

      if (paymentResult.isSuccess) {
        shouldResetTurnstile = false;
        alert("Payment successful! Redirecting you back...");
        console.log("Payment successful! Redirecting to:", returnUrl);
        window.location.href = returnUrl;
      } else {
        setError(`Payment failed: ${paymentResult.message}`);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Error in payment process:", error);

      let errorMessage = "Payment processing failed.";
      if (error.response) {
        const errorData = error.response.data;

        const displayError =
          errorData.errorMessage ||
          errorData.message ||
          errorData.Message ||
          "Payment processing failed.";

        errorMessage = `
ERROR FROM SERVER:

Status Code: ${error.response.status}

Error Message: ${displayError}

Please check your card details and try again.
        `;

        setError(
          errorData?.Data?.errorMessage ||
            errorData?.errorMessage ||
            errorData?.message ||
            errorData?.Message ||
            "Card verification failed.",
        );
      } else if (error.request) {
        errorMessage = `
NETWORK ERROR:

No response from server. Please check your internet connection.

Error: ${error.message}
        `;
        alert("Network error. Please check your connection.");
        setError("Network error. Please check your connection.");
      } else {
        errorMessage = `
ERROR:

${error.message}
        `;
        alert(error.message);
        setError(error.message);
      }
      console.log("Detailed Error Message:", errorMessage);
    } finally {
      if (shouldResetTurnstile) {
        setTurnstileResetCounter((current) => current + 1);
      }
      setIsSubmitting(false);
    }
  };

  const handleGooglePaySuccess = async (monerisResponse) => {
    try {
      setIsSubmitting(true);
      setError("");

      console.log("[API Request] Sending to recordGooglePayTransaction:", {
        paymentGuid,
        monerisResponse,
      });

      const response = await recordGooglePayTransaction(
        paymentGuid,
        monerisResponse,
        saveCard,
      );

      console.log("[API Response] recordGooglePayTransaction:", response.data);

      const result =
        response.data?.content || response.data?.Content || response.data;

      if (result.isSuccess) {
        alert("Google Pay payment successful! Redirecting you back...");
        window.location.href = returnUrl;
      } else {
        setError(`Failed to complete payment: ${result.message}`);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("[API Error]", error.response?.data || error);

      if (error.response) {
        const errorData = error.response.data;
        const displayError =
          errorData.errorMessage ||
          errorData.message ||
          errorData.Message ||
          "Payment was approved but failed to record. Please contact support.";
        setError(displayError);
      } else if (error.request) {
        setError(
          "Network error. Payment may have been processed. Please contact support.",
        );
      } else {
        setError(error.message);
      }
      setIsSubmitting(false);
    }
  };

  const handleGooglePayError = (error) => {
    console.error("[GooglePay Error]", error);
    setError(error.message || "Google Pay payment failed. Please try again.");
    setIsSubmitting(false);
  };

  const handleExpirationInput = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 2) {
      value = value.slice(0, 2) + "/" + value.slice(2, 4);
    }
    setExpiration(value);
  };
  return (
    <Wrapper>
      <Container>
        <RowContainer>
          <Logo />
          {/* left section */}
          <AmountSection>
            <h3>Your total amount is:</h3>
            <h1>
              <CurrencySymbol>USD </CurrencySymbol>
              <Amount>
                $
                {displayAmount !== null
                  ? displayAmount.toFixed(2)
                  : "Loading..."}
              </Amount>
            </h1>
          </AmountSection>

          {/* right payment section */}
          <FormSection>
            <PaymentForm onSubmit={handleSubmit}>
              <FormGroup>
                <label>Card Number</label>
                <Input
                  type="text"
                  value={cardNumber}
                  onChange={(e) =>
                    setCardNumber(e.target.value.replace(/\D/g, ""))
                  }
                  placeholder="1234 5678 9012 3456"
                  maxLength="20"
                  required
                />
              </FormGroup>

              <FormGroup>
                <label>Name on Card</label>
                <Input
                  type="text"
                  value={cardName}
                  onChange={(e) => setCardName(e.target.value)}
                  placeholder="James Smith"
                  required
                />
              </FormGroup>

              <FormGroup>
                <label>Expiration Date</label>
                <Input
                  type="text"
                  value={expiration}
                  onChange={handleExpirationInput}
                  placeholder="MM/YY"
                  maxLength="5"
                  required
                />
              </FormGroup>
              <FormGroup>
                <label>CVV</label>
                <Input
                  type="text"
                  value={cvv}
                  onChange={(e) => setCvv(e.target.value)}
                  placeholder="123"
                  maxLength="4"
                  required
                />
              </FormGroup>

              <CheckboxContainer htmlFor="saveCardCheckbox">
                <Checkbox
                  id="saveCardCheckbox"
                  type="checkbox"
                  checked={saveCard}
                  onChange={(e) => setSaveCard(e.target.checked)}
                />
                <p>
                  Save for auto-payment{" "}
                  {autoPayDiscount > 0 && (
                    <span>and get ${autoPayDiscount.toFixed(2)} discount</span>
                  )}
                </p>
              </CheckboxContainer>

              <FormGroup>
                <label>Security Verification</label>
                <TurnstileContainer>
                  <TurnstileWidget
                    siteKey={turnstileSiteKey}
                    resetCounter={turnstileResetCounter}
                    onTokenChange={setTurnstileToken}
                    onError={setError}
                  />
                </TurnstileContainer>
              </FormGroup>

              <ButtonContainer>
                <PayButton
                  type="submit"
                  disabled={isSubmitting || !turnstileToken}
                >
                  {isSubmitting ? <Spinner /> : "Confirm and Pay"}
                </PayButton>
              </ButtonContainer>
              {error && (
                <p style={{ color: "red", textAlign: "center" }}>{error}</p>
              )}

              <Divider>
                <DividerLine />
                <DividerText>OR</DividerText>
                <DividerLine />
              </Divider>

              <GooglePayButton
                amount={amount}
                paymentGuid={paymentGuid}
                onPaymentSuccess={handleGooglePaySuccess}
                onPaymentError={handleGooglePayError}
                disabled={isSubmitting}
              />

              <ButtonContainer>
                <CancelButton onClick={handleCancel} type="button">
                  Cancel
                </CancelButton>
              </ButtonContainer>
            </PaymentForm>
          </FormSection>
        </RowContainer>

        <Separator />

        <Footer />
      </Container>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  background: #f7f9fc;
  min-height: 100vh;
  padding: 20px 0;
`;
const Container = styled.div`
  max-width: 1000px;
  margin: 100px auto;
  padding: 64px 64px 32px 64px;
  border-radius: 24px;
  background: white;
  box-shadow:
    0 -2px 4px 0 rgba(0, 79, 232, 0.1) inset,
    0 0 8px 0 rgba(0, 62, 181, 0.12);
  font-family: "Helvetica", "Arial", sans-serif;

  @media (max-width: 768px) {
    max-width: none;
    margin: 1rem 0 0 0;
    padding: 1rem;
  }
`;

const RowContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const AmountSection = styled.div`
  text-align: center;
  margin-left: 50px;

  @media (max-width: 768px) {
    margin-top: 64px;
    margin-left: 0;
    width: 100%;
  }
  h3 {
    font-weight: 500;
    font-size: 24px;
    letter-spacing: -0.64px;
    line-height: normal;
  }
  h1 {
    color: #000;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.64px;
  }
`;

const CurrencySymbol = styled.span`
  font-size: 1.5rem;
`;

const Amount = styled.span`
  color: #0057ff;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.96px;
`;

const FormSection = styled.div`
  min-width: 400px;

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

const PaymentForm = styled.form``;

const FormGroup = styled.div`
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  label {
    color: #0f1115;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
  }
`;

const Input = styled.input`
  padding: 16px 20px;
  font-size: 16px;
  margin-top: 10px;

  border-radius: 8px;
  border: 1px solid rgba(138, 178, 255, 0.24);
  background: #e6eeff;

  &::placeholder {
    color: rgba(0, 48, 140, 0.4);
    font-size: 16px;
    font-weight: 400;
    line-height: 1;
    letter-spacing: -0.192px;
  }
`;

const TurnstileContainer = styled.div`
  margin-top: 10px;
`;

// const Row = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 10px;

//   @media (max-width: 768px) {
//     flex-direction: column;
//   }
// `;

const CheckboxContainer = styled.label`
  margin: 24px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  color: #3f444c;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

const Checkbox = styled.input`
  cursor: pointer;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid #548eff;
  background: #fff;

  appearance: none;
  -webkit-appearance: none;
  display: grid;
  place-content: center;

  &:checked {
    background: #548eff;
  }

  &:checked::after {
    content: "";
    width: 10px;
    height: 6px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(-45deg);
    margin-top: -4px;
  }

  &:focus-visible {
    outline: 2px solid rgba(84, 142, 255, 0.35);
    outline-offset: 2px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  /* border: 1px solid red; */
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: ${spin} 1s linear infinite;
  display: inline-block;
`;

const PayButton = styled.button`
  width: 100%;
  padding: 16px 40px;
  font-weight: 500;
  background: #004fe8;
  font-size: 16px;
  font-weight: 500;
  border: none;
  color: white;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  border-radius: 12px;
  transition: 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover {
    background-color: #d03759;
  }

  &:disabled {
    background: gray;
  }
`;

const CancelButton = styled(PayButton)`
  background: black;
  margin-top: 10px;
  color: #004fe8;
  border-radius: 12px;
  border: 1px solid rgba(221, 225, 230, 0.48);
  background: #e6eeff;
  box-shadow:
    0 -2px 4px 0 rgba(0, 79, 232, 0.1) inset,
    0 0 8px 0 rgba(0, 62, 181, 0.08);
`;

const Separator = styled.hr`
  margin: 30px 0;
  border: none;
  border-top: 1px solid #ddd;
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;
  gap: 10px;
`;

const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: #ddd;
`;

const DividerText = styled.span`
  color: #999;
  font-size: 14px;
  font-weight: 500;
`;

export default Home;
